import { loginError, loginStart, loginSuccess, logoutFailure, logoutSuccess } from "../constants/login";

const initialState = {
  isProcessing: false,
  isError: false,
  data: null
}

function handleReducer(state=initialState, action) {
  switch(action.type) {
    case loginStart:
      return {...state, isProcessing: true};

    case loginError:
      return {...state, isError: true};

    case loginSuccess:
      return {...state, data: action.payload}

    case logoutFailure: 
      return state;
    
    case logoutSuccess:
      return initialState;
    
    default:
      return state;
  }
}

export const loginReducer = (state, action) => {
  return handleReducer(state, action);
}